import React from 'react'
import'./Loading.css'
export default function Loading() {
  return (
    <div className='mt-5 py-5'>
      <div className='loading-spinner'></div>
    </div>
  )
}
